import "../src/global/global-mobile"
import "@modules/advert-cards/advert-cards"

import "@modules/top-adverts/top-adverts"
import "@modules/tracking/previous-next-advert-cookie"

import "@modules/browser-extension/open-with-gesamt-icons.css"

import "@modules/azm"
import "@modules/azm/anzeigenmarkt-styles-mobile.css"

import "@modules/big-teaser/big-teaser"
import "@modules/big-teaser/big-teaser-mobile.css"
import "@modules/azm/not-found-azm.css"

import "@modules/location/LocationSelector"
import "@modules/solads/solads"
import "@modules/vue-modals/ad-free"
import "@modules/vue-modals/age-verification.js"
import "@modules/vue-modals/coins"

import "@modules/banner/header-banner-mobile"
import "@modules/banner/banner-mobile.css"
import "@modules/global/header-mobile.css"
import "@modules/banner/donnerstag/header-donnerstag-mobile.css"
import "@modules/banner/donnerstag/footer-donnerstag-mobile.css"
import "@modules/banner/mittwoch/header-mittwoch-mobile.css"
import "@modules/banner/mittwoch/footer-mittwoch-mobile.css"
// import "@modules/banner/muenchen/muenchen-messe-mobile.css"
import "@modules/banner/muenchen/muenchen-auto-messe-mobile.css"
// import "@modules/banner/muenchen/muenchen-valentines-mobile.css"
// import "@modules/banner/muenchen/muenchen-wiesn-mobile.css"
import "@modules/banner/city-highlight/city-highlight"
import "@modules/banner/city-highlight/header-city-highlight-mobile.css"
import "@modules/stars-top-creator-stripe/starsTopCreatorStripeIndex.ts"

import { setFilterPathLocationToSessionStorage } from "@modules/global/filter-path/filter-path-handler.ts"
setFilterPathLocationToSessionStorage("azm")

import { initSwiperContainer } from "@modules/util/swiper.ts"
import type { SwiperContainer } from "swiper/element"
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import type { SwiperOptions } from "swiper/types"

const swiperContainer = document.querySelector("#muenchen-highlight-container") as SwiperContainer
requestAnimationFrame(() => {
    initSwiperContainer(swiperContainer, {
        loop: true,
        pagination: true,

        speed: 1500,
        watchOverflow: true,
        centeredSlides: true,
        slidesPerView: 1,
        loopAdditionalSlides: 3,

        breakpoints: {
            340: { spaceBetween: -120 },
            350: { spaceBetween: -130 },
            360: { spaceBetween: -140 },
            370: { spaceBetween: -150 },
            380: { spaceBetween: -160 },
            390: { spaceBetween: -170 },
            400: { spaceBetween: -180 },
            410: { spaceBetween: -190 },
            420: { spaceBetween: -200 },
            430: { spaceBetween: -210 },
            440: { spaceBetween: -220 },
            450: { spaceBetween: -230 },
            460: { spaceBetween: -240 },
            470: { spaceBetween: -250 },
        },
        on: {
            breakpoint(swiper) {
                for (const slide of Object.values(swiper.slides)) {
                    if (slide.classList.contains("swiper-slide-blank")) {
                        slide.parentElement?.removeChild(slide)
                    }
                }
                // force loop re-init
                swiper.loopDestroy()
                swiper.loopCreate()
                swiper.update()
            },
        },

        modules: [Autoplay, Navigation, Pagination],
        autoplay: {
            delay: 0,
        },
    } as SwiperOptions)
})
